import { React, useEffect, useState } from "react";
import { RoundCard, RunnerUpHeader, TableWork } from "../../../ui";
import SelectField from "../../../library/components/Select";
import { useGetCountingSupervisorDeoReportQuery } from "../../../services/reportsServices";
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const selectConstituencyType = [
  { value: "AC", label: "AC" },
  { value: "PC", label: "PC" },
];
const CountingSupervisorDeoReport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const [data, setData] = useState({
    constituencyType: "AC",
  });
  const reportName = "Counting Supervisor Report"
  const SheetName = "Counting Supervisor Report"
  const tableData = [];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "District No. and Name",
      accessor: "col2",
    },
    {
      Header: "AC/PC No. and Name",
      accessor: "col3",
    },
    {
      Header: "Counting Supervisor Id and Name",
      accessor: "col4",
    },
    {
      Header: "Mobile Number",
      accessor: "col5",
    },
    {
      Header: "Email Id",
      accessor: "col6",
    },
    {
      Header: "Login Status",
      accessor: "col7",
    },
    {
      Header: "Scanning Status",
      accessor: "col8",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })
  const { data: GetCountingSupervisorDeoReport } =
    useGetCountingSupervisorDeoReportQuery(data.constituencyType);

  GetCountingSupervisorDeoReport?.payload?.map((item) => {
    tableData.push({
      "col1": item.stateName,
      "col2": `${item.districtCd} ${item.districtName}`,
      "col3": `${item.acPcNo} ${item.acPcName}`,
      "col4": `${item.userId} ${item.userName}`,
      "col5": item.mobileNo,
      "col6": item.userEmailId,
      "col7": item.loginStatus==="Y"?"Yes":"No",
      "col8": item.scanningStatus==="Y"?"Started":"Not Started",
    });
  });

  useEffect(()=>{
    setTotalNoOfRecords(GetCountingSupervisorDeoReport?.payload?.length)
  },[GetCountingSupervisorDeoReport])

  const handleChange = (key, value) => {
    setData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  return (
    <LeftMenu>
    <div className="container box shadow ">
     <RunnerUpHeaderNew title={reportName} 
       state={ <span
                  >
                    State: {GetCountingSupervisorDeoReport?.state}{" "}
                    <span style={{ marginLeft: "13px" }}></span>District :{" "}
                    {GetCountingSupervisorDeoReport?.district}
                    </span>}
  onPdfClick={() => downloadPdfFile(reportName, tableHeader, tableData)} 
  onExcelClick={() => downloadExcelFile(reportName, SheetName, tableHeader, tableData)}
  />
      <div className="row">
        <SelectField
        labelClass=""
          inputClass="col-md-2"
          options={selectConstituencyType}
          value={data.constituencyType}
          handleChange={(val) => handleChange("constituencyType", val)}
        ></SelectField>
      </div>
      <div style={{ marginTop: "-40px" }}>
        <Table
          placeholder="Search"
          globalsearch={true}
          selectall={true}
          emptyMessage="No Record Found"
          columns={columns}
          data={tableData?.length === 0 ? [] : tableData}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        />
      </div>
    </div>
</LeftMenu>
  );
};

export default CountingSupervisorDeoReport;
